import G2 from '@antv/g2';
import  DataSet from '@antv/data-set';
import countTo from 'vue-count-to';

export default {
    name: 'DataVisualization',
    components: { countTo },
    data () {
        return {
            startVal: 0,
            periods:0,
            orders:0,
            Users:0,
            earnings:0
        }
    },
    methods: {
        //获取总课时
        getPeriods(){
            let data1={
                offset:0,
                length:99999,
                shop_id:1
            }
            this.$post('products/get_all_period', data1).then(res => {
                let sum = 0
                for(let a of res.data.result.data){
                    a.period = + a.period
                    sum += a.period
                }
                this.periods = sum
            })
        },

        //获取订单数
        getOrders(){
            let data={
                offset:0,
                length:99999,
                shop_id:1
            }
            this.$post('orders/get_all_orders', data).then(res => {
                this.orders = res.data.result.total
            })
        },

        //查询学员数量
        getUsers(){
            let data={
                offset:0,
                length:99999,
                id:41,
                shop_id:1
            }
            this.$post('users/get_user', data).then(res => {
                this.Users = res.data.result.total
            })
        },

        //获取收益
        getEarnings(){
            var myDate = new Date();
            let year = myDate.getFullYear();  
            let month = myDate.getMonth()+1;
            let arr = []
            if(year == 2019){
                for(let a = 4;a<=month;a++){
                    let obj = {}
                    let b = a.toString().padStart(2,0)                  
                    obj.time = year + '-' + b
                    obj.price = 0
                    arr.push(obj)
                }
            }
         
            let data={
                offset:0,
                length:99999,
                shop_id:1
            }

            this.$post('orders/get_earnings', data).then(res => {
                for(let a of res.data.result.data){
                    let str = a.created_at
                    a.total = Number(a.total)
                    this.earnings += a.total
                    for(let b of arr){
                        if(str.indexOf(b.time) != -1){
                            b.price = + b.price
                            b.price += a.total
                        }
                    }
                }
                // console.log(arr)
                // console.log(this.earnings)
                this.draw(arr)
            })
        },

        //画柱状图
        draw(arr){
            var chart = new G2.Chart({
                container: 'amount',
                forceFit: true,
                width:window.innerWidth,
                height: window.innerHeight
            });
            chart.source(arr);
            chart.scale('price', {
                tickInterval: 50000
            });
            chart.interval().position('time*price');
            chart.render();
        },
    },
    created(){
        this.getPeriods()
        this.getOrders()
        this.getUsers()
    },
    mounted() {
        this.getPeriods()
        this.getEarnings()
    }
}